import { render } from "./MerchandisesViewsDetail.vue?vue&type=template&id=8a1ed61a&scoped=true"
import script from "./MerchandisesViewsDetail.vue?vue&type=script&lang=js"
export * from "./MerchandisesViewsDetail.vue?vue&type=script&lang=js"

import "./MerchandisesViewsDetail.vue?vue&type=style&index=0&id=8a1ed61a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1ed61a"]])

export default __exports__